export default class ConsultaReclamacionesModel {
  image: string;
  title: string;
}
